var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"global"},[(_vm.isNavBarVisibility)?_c('NavBar',{attrs:{"id":"nav"}}):_vm._e(),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"},on:{"before-enter":_vm.scrollTop}},[_c('router-view',{attrs:{"id":"util-view"}})],1),(_vm.getFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }